import { Link } from 'react-router-dom';

const ServicesOverview = () => {
  const services = [
    {
      icon: 'ri-cpu-line',
      title: 'Electronic Components Import',
      description: 'Comprehensive import and wholesale trade of microelectronics, sensors, cables, modules, and circuit boards from reliable global suppliers with strict quality control.',
      features: ['Microelectronics', 'Sensors & Modules', 'Quality Assurance'],
      image: 'https://public.readdy.ai/ai/img_res/07be7cb04a5477d8fceda4cff75981fa.jpg',
    },
    {
      icon: 'ri-global-line',
      title: 'Wholesale Distribution for EU & Ukraine',
      description: 'Fast order processing and efficient B2B deliveries to enterprises and system integrators across European and Ukrainian markets through our extensive warehouse network.',
      features: ['Fast Processing', 'Wide Network', 'B2B Solutions'],
      image: 'https://readdy.ai/api/search-image?query=global%20logistics%20network%20map%20with%20connection%20lines%20between%20europe%20and%20ukraine%20modern%20warehouse%20facility%20with%20organized%20inventory%20corporate%20business%20environment%20clean%20professional%20setting%20with%20blue%20and%20white%20color%20scheme%20technology%20integration&width=600&height=400&seq=service-002&orientation=landscape',
    },
    {
      icon: 'ri-tools-line',
      title: 'Technical Spare Parts Supply',
      description: 'Reliable supply of mechanical, electrical, and industrial spare parts for technical systems and machinery with replacement components for various equipment types.',
      features: ['Industrial Parts', 'Equipment Components', 'Quick Availability'],
      image: 'https://readdy.ai/api/search-image?query=precision%20mechanical%20and%20electrical%20spare%20parts%20industrial%20components%20arranged%20systematically%20on%20clean%20surface%20technical%20equipment%20parts%20with%20metallic%20finish%20professional%20product%20photography%20with%20neutral%20background%20and%20focused%20lighting&width=600&height=400&seq=service-003&orientation=landscape',
    },
    {
      icon: 'ri-truck-line',
      title: 'International Logistics Support',
      description: 'Complete cargo coordination, customs support, and delivery route optimization with full-cycle accompaniment of international shipments across multiple transport modes.',
      features: ['Cargo Coordination', 'Customs Support', 'Route Optimization'],
      image: 'https://readdy.ai/api/search-image?query=modern%20cargo%20transportation%20logistics%20trucks%20and%20shipping%20containers%20at%20international%20terminal%20professional%20freight%20operations%20with%20organized%20workflow%20clean%20corporate%20environment%20blue%20sky%20background%20efficient%20supply%20chain%20management&width=600&height=400&seq=service-004&orientation=landscape',
    },
  ];

  return (
    <section className="py-24 px-6 lg:px-12 bg-gradient-to-b from-white to-slate-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-blue-50 rounded-full mb-6">
            <i className="ri-service-line text-blue-600"></i>
            <span className="text-sm text-blue-600 font-semibold">Our Services</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            Comprehensive <strong>Technical Solutions</strong>
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            From electronic components import to international logistics, we provide end-to-end solutions for your technical and supply chain needs.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top transform group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-black/10 group-hover:bg-black/20 transition-all duration-500"></div>
                <div className={`absolute top-6 left-6 w-20 h-20 bg-gradient-to-br from-blue-600 to-cyan-500 rounded-2xl flex items-center justify-center shadow-lg`}>
                  <i className={`${service.icon} text-white text-4xl`}></i>
                </div>
              </div>

              <div className="p-8">
                <h3 className="text-2xl font-bold text-slate-900 mb-4 group-hover:text-blue-600 transition-colors duration-300">
                  {service.title}
                </h3>
                <p className="text-slate-600 mb-6 leading-relaxed">
                  {service.description}
                </p>

                <div className="flex flex-wrap gap-2 mb-6">
                  {service.features.map((feature, idx) => (
                    <span
                      key={idx}
                      className="px-3 py-1 bg-slate-50 text-slate-700 text-sm rounded-full border border-slate-200"
                    >
                      {feature}
                    </span>
                  ))}
                </div>

                <Link
                  to="/services"
                  className="inline-flex items-center text-blue-600 font-semibold hover:text-blue-700 transition-colors duration-300 cursor-pointer group/link"
                >
                  Learn More
                  <i className="ri-arrow-right-line ml-2 transform group-hover/link:translate-x-2 transition-transform duration-300"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/services"
            className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-blue-600 to-cyan-500 text-white text-lg font-semibold rounded-lg hover:shadow-xl hover:scale-105 transition-all duration-300 whitespace-nowrap"
          >
            View All Services
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview;
